import PropTypes from "prop-types";

import {
  SINGLE_CONTINUOUS,
  SINGLE_PER_PAGE,
  DOUBLE_CONTINUOUS,
  DOUBLE_PER_PAGE
} from "~/constants/page-modes";

import {
  STUDENT_MODE,
  DLS_MODE,
  PRESENTATION_MODE
} from "~/constants/presentation-modes";

export const browserType = PropTypes.shape({
  mediaType: PropTypes.string,
  orientation: PropTypes.oneOf(["portrait", "landscape"]),
  lessThan: PropTypes.objectOf(PropTypes.bool),
  greaterThan: PropTypes.objectOf(PropTypes.bool),
  is: PropTypes.objectOf(PropTypes.bool)
});

export const storeType = PropTypes.shape({
  getState: PropTypes.func,
  dispatch: PropTypes.func,
  subscribe: PropTypes.func,
  replaceReducer: PropTypes.func
});

export const positionType = PropTypes.shape({
  _id: PropTypes.string,
  page: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  marginal: PropTypes.bool
});

export const materialType = PropTypes.shape({
  _id: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  linktext: PropTypes.string,
  src: PropTypes.string,
  description: PropTypes.string,
  position: positionType,
  materialType: PropTypes.string,
  renderType: PropTypes.string,
  mimeType: PropTypes.string,
  sourcePath: PropTypes.string,
  linkText: PropTypes.string,
  shortDescription: PropTypes.string
});

export const refType = PropTypes.shape({
  current: PropTypes.instanceOf(Element)
});

export const zoomControllerType = PropTypes.shape({
  zoomToFit: PropTypes.func,
  zoomToFitAgain: PropTypes.func,
  zoomIn: PropTypes.func,
  zoomOut: PropTypes.func,
  zoomParentRef: refType,
  zoomChildRef: refType,
  getScale: PropTypes.func,
  pause: PropTypes.func,
  resume: PropTypes.func
});

export const pageModeType = PropTypes.oneOf([
  SINGLE_CONTINUOUS,
  SINGLE_PER_PAGE,
  DOUBLE_CONTINUOUS,
  DOUBLE_PER_PAGE
]);

export const displayModeType = PropTypes.oneOf([
  STUDENT_MODE,
  DLS_MODE,
  PRESENTATION_MODE
]);
